<template>
    <img
        :alt="data.title"
        :src="data.image_url"
    />
    <slot></slot>
</template>

<script>
export default {
    props: ["data"],
};
</script>
